import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinnavimumbai() {



    const cardData = {

keyword: "Cab Service in Navi Mumbai",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Cab Service in Navi Mumbai for local travel, airport transfers, corporate commuting, family trips, and outstation journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and verified chauffeurs. With 24x7 availability, doorstep pickup and drop across Navi Mumbai, transparent pricing, instant booking support, and comfortable rides, we ensure a safe, smooth, and hassle-free travel experience for all passengers in Navi Mumbai and nearby regions.",

topPlaces: [
    {
        title: "Pune",
        description:
            "Pune is a major IT, education, and business hub near Navi Mumbai known for its pleasant climate, cultural heritage, and modern lifestyle. It is one of the most frequently booked outstation cab routes for work, study, and family travel."
    },
    {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are popular hill stations known for waterfalls, green valleys, caves, and scenic viewpoints. They are ideal for weekend trips and monsoon drives from Navi Mumbai."
    },
    {
        title: "Goa",
        description:
            "Goa is India’s most popular beach destination famous for nightlife, beaches, water sports, and Portuguese heritage. It is a top long-distance holiday destination from Navi Mumbai."
    },
    {
        title: "Nashik & Trimbakeshwar",
        description:
            "Nashik is a spiritual and wine tourism destination known for Trimbakeshwar Jyotirlinga, vineyards, and river ghats. It is widely visited for pilgrimage and weekend tours."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of the most important pilgrimage destinations in India dedicated to Sai Baba. It is a highly preferred cab route for spiritual and religious travel from Navi Mumbai."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a scenic hill station known for strawberries, viewpoints, lakes, and cool weather. It is perfect for long weekend family vacations."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a coastal beach destination near Navi Mumbai known for clean beaches, forts, and resorts. It is ideal for quick weekend getaways and relaxation trips."
    },
    {
        title: "Igatpuri",
        description:
            "Igatpuri is a peaceful hill station surrounded by mountains and waterfalls. It is a popular monsoon destination for nature lovers and short trips."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is a historical city famous for Ajanta and Ellora Caves. It is a cultural and heritage destination for long-distance cab travel from Navi Mumbai."
    },
    {
        title: "Daman & Diu",
        description:
            "Daman and Diu are coastal destinations known for beaches, Portuguese forts, and relaxed atmosphere. They are ideal for budget-friendly weekend trips from Navi Mumbai."
    }
],



services: [
{
name: "Cab Service in Navi Mumbai",
description: "Mumbai Airport Cab offers Cab Service in Navi Mumbai with safe, comfortable, and reliable transportation across all nodes including Vashi, Nerul, Belapur, Kharghar, Airoli, and Panvel. We provide AC Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, and luxury vehicles for local travel, airport transfers, corporate trips, family outings, and outstation journeys with professional chauffeurs and 24x7 service."
},
{
name: "Navi Mumbai Cab Service",
description: "Navi Mumbai Cab Service provides dependable and affordable travel solutions with clean vehicles, experienced drivers, and quick pickup for daily commuting, city travel, and long-distance trips."
},
{
name: "Taxi Service in Navi Mumbai",
description: "Taxi Service in Navi Mumbai ensures safe and convenient transportation with professional chauffeurs, well-maintained vehicles, and reliable service for local and intercity travel."
},
{
name: "Navi Mumbai Local Cab",
description: "Navi Mumbai Local Cab offers quick and affordable intra-city rides across all Navi Mumbai locations including residential, commercial, and industrial areas with smooth travel experience."
},
{
name: "Navi Mumbai Outstation Cab",
description: "Navi Mumbai Outstation Cab provides long-distance travel to destinations like Pune, Nashik, Goa, Shirdi, and beyond with comfortable vehicles and experienced drivers."
},
{
name: "Navi Mumbai Airport Cab Service",
description: "Navi Mumbai Airport Cab Service ensures timely pickup and drop for Mumbai Airport with flight tracking, luggage assistance, and professional chauffeurs for stress-free travel."
},
{
name: "24x7 Cab Service Navi Mumbai",
description: "24x7 Cab Service Navi Mumbai offers round-the-clock transportation for airport transfers, emergency rides, night travel, and planned journeys with safe and reliable service."
},
{
name: "Affordable Cab Service Navi Mumbai",
description: "Affordable Cab Service Navi Mumbai provides budget-friendly travel options with transparent pricing, clean cars, and dependable drivers for daily commuting and trips."
},
{
name: "Reliable Cab Service Navi Mumbai",
description: "Reliable Cab Service Navi Mumbai ensures punctual pickups, verified drivers, GPS-enabled vehicles, and consistent service quality for all types of travel."
},
{
name: "Navi Mumbai City Cab Service",
description: "Navi Mumbai City Cab Service covers all major areas with quick response time, easy booking, and comfortable rides for office, shopping, and personal travel."
},
{
name: "Navi Mumbai Ride Service",
description: "Navi Mumbai Ride Service offers on-demand transportation with instant booking, nearby driver allocation, and smooth travel experience across the city."
},
{
name: "Navi Mumbai Travel Cab Service",
description: "Navi Mumbai Travel Cab Service provides flexible travel solutions for local and outstation trips with professional chauffeurs and multiple vehicle options."
},
{
name: "Navi Mumbai Corporate Cab Service",
description: "Navi Mumbai Corporate Cab Service offers professional transportation for employees, executives, and business travel with punctual and reliable service."
},
{
name: "Navi Mumbai Family Cab Service",
description: "Navi Mumbai Family Cab Service provides spacious and safe vehicles ideal for family trips, vacations, and weekend travel with comfortable seating."
},
{
name: "Navi Mumbai Online Cab Booking",
description: "Navi Mumbai Online Cab Booking allows quick and easy booking with instant confirmation, multiple vehicle choices, and 24x7 customer support."
},
{
name: "Navi Mumbai Instant Cab Service",
description: "Navi Mumbai Instant Cab Service ensures fast pickup with nearby driver allocation for urgent travel needs and emergency transportation."
},
{
name: "Navi Mumbai Intercity Cab",
description: "Navi Mumbai Intercity Cab provides smooth travel between Navi Mumbai and major cities with experienced chauffeurs and comfortable long-route vehicles."
},
{
name: "Navi Mumbai Highway Cab Service",
description: "Navi Mumbai Highway Cab Service ensures safe long-distance highway travel with well-maintained vehicles and trained professional drivers."
},
{
name: "Navi Mumbai Premium Cab Service",
description: "Navi Mumbai Premium Cab Service offers luxury vehicles and executive travel experience with high comfort, privacy, and premium chauffeur service."
},
{
name: "Navi Mumbai Budget Cab Service",
description: "Navi Mumbai Budget Cab Service provides economical travel solutions with affordable fares, clean vehicles, and reliable service for everyday use."
}
],

tableData: [
["Cab Service in Navi Mumbai","Navi Mumbai Cab Service"],
["Taxi Service in Navi Mumbai","Navi Mumbai Local Cab"],
["Navi Mumbai Outstation Cab","Navi Mumbai Airport Cab Service"],
["24x7 Cab Service Navi Mumbai","Affordable Cab Service Navi Mumbai"],
["Reliable Cab Service Navi Mumbai","Navi Mumbai City Cab Service"],
["Navi Mumbai Ride Service","Navi Mumbai Travel Cab Service"],
["Navi Mumbai Corporate Cab Service","Navi Mumbai Family Cab Service"],
["Navi Mumbai Online Cab Booking","Navi Mumbai Instant Cab Service"],
["Navi Mumbai Intercity Cab","Navi Mumbai Highway Cab Service"],
["Navi Mumbai Premium Cab Service","Navi Mumbai Budget Cab Service"]
],



whychoose: [
    {
        WhyChooseheading: "Reliable Cab Service in Navi Mumbai",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Cab Services in Navi Mumbai for local travel, airport transfers, outstation journeys, corporate transportation, and daily commuting requirements."
    },
    {
        WhyChooseheading: "24x7 Transportation Across Navi Mumbai",
        WhyChoosedescription: "Our cab service operates round the clock, helping customers travel conveniently for business meetings, airport transfers, family functions, and emergency transportation needs."
    },
    {
        WhyChooseheading: "Local and Outstation Travel Solutions",
        WhyChoosedescription: "Whether you need a cab within Navi Mumbai or for destinations like Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, or Ahmedabad, we offer comfortable travel options."
    },
    {
        WhyChooseheading: "Wide Fleet of Comfortable Vehicles",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "Airport Pickup and Drop Specialists",
        WhyChoosedescription: "We provide timely airport transfer services between Navi Mumbai and Mumbai Airport with professional drivers and comfortable vehicles." 
    },
    {
        WhyChooseheading: "Coverage Across Major Navi Mumbai Locations",
        WhyChoosedescription: "Our cab services are available in Vashi, Nerul, Belapur, Kharghar, Panvel, Airoli, Ghansoli, Kopar Khairane, Sanpada, and surrounding areas." 
    },
    {
        WhyChooseheading: "Professional Drivers and Safe Travel",
        WhyChoosedescription: "Our experienced chauffeurs ensure safe driving, punctual service, route expertise, and customer satisfaction throughout every journey."
    },
    {
        WhyChooseheading: "Suitable for Families, Tourists, and Corporate Travelers",
        WhyChoosedescription: "From solo travelers and families to corporate executives and group travelers, we provide suitable transportation solutions for every requirement."
    }
]
};

const faqData = [
    {
        question: "What services are included in Cab Service in Navi Mumbai?",
        answer: "Mumbai Airport Cabs offers local city rides, airport transfers, outstation travel, corporate transportation, sightseeing tours, and customized cab services."
    },
    {
        question: "Can I book a cab from Navi Mumbai to Mumbai Airport?",
        answer: "Yes, airport pickup and drop services are available between Navi Mumbai and Mumbai Airport for domestic and international travelers."
    },
    {
        question: "Which vehicles are available for booking in Navi Mumbai?",
        answer: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
    },
    {
        question: "Do you provide outstation cab services from Navi Mumbai?",
        answer: "Yes, outstation cab services are available for Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, Ahmedabad, Indore, and many other destinations."
    },
    {
        question: "Can corporate clients use your cab service in Navi Mumbai?",
        answer: "Yes, we provide transportation services for corporate offices, executives, employees, business travelers, and corporate events."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family tours, corporate outings, weddings, and group transportation."
    },
    {
        question: "Can I schedule a cab in advance?",
        answer: "Yes, advance booking is recommended to secure your preferred vehicle and ensure a smooth travel experience."
    },
    {
        question: "Do you provide local sightseeing cabs from Navi Mumbai?",
        answer: "Yes, customers can book cabs for Mumbai Darshan, Navi Mumbai sightseeing, shopping trips, and customized travel plans."
    },
    {
        question: "Are your drivers experienced and verified?",
        answer: "Yes, all drivers are professionally trained, experienced, and familiar with local as well as outstation routes."
    },
    {
        question: "How can I book a Cab Service in Navi Mumbai?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sameer Patil",
        feedback:
            "I regularly travel from Belapur to Mumbai Airport and the service has always been punctual. The drivers are professional and the vehicles are maintained exceptionally well.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Aarti Shah",
        feedback:
            "Mumbai Airport Cabs provided excellent transportation for our family trip from Navi Mumbai. The booking process was simple, the cab was comfortable, and the entire journey was hassle-free.",
        rating: 5
    }
];










































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Cab Service in Navi Mumbai",
"image": "https://www.mumbaiairportcabs.com/assets/images/cab-service-in-navi-mumbai.jpg",
"description": "Book cab service in Navi Mumbai for local travel, airport transfers, outstation trips, and daily commuting. Mumbai Airport Cabs offers 24x7 reliable taxi service with professional drivers, clean vehicles, affordable pricing, and easy online booking across Navi Mumbai.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/cab-service-in-navi-mumbai"
}
};





    return (
        <div>



<Helmet>
  <title>Cab Service in Navi Mumbai | 24x7 Taxi Booking | +91 9545731161</title>

<meta
 name="description"
 content="Book cab service in Navi Mumbai for local rides, airport transfers, and outstation travel. 24x7 reliable taxi service with affordable fares, professional drivers, and easy booking."
/>

<meta
 name="keywords"
 content="cab service in navi mumbai, navi mumbai cab service, taxi service in navi mumbai, navi mumbai local cab, navi mumbai outstation cab, navi mumbai airport cab service, 24x7 cab service navi mumbai, affordable cab service navi mumbai, reliable cab service navi mumbai, navi mumbai city cab service, navi mumbai ride service, navi mumbai travel cab service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/72.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinnavimumbai;